import { Dropdown, Text, Tooltip } from '@loadsmart/miranda-react';
import { PBIExportableReport } from 'managed-analytics/domain/PBIReport';
import {
  StyledFieldWrapper,
} from '../../scheduler/Scheduler.styles';

interface Props {
  selectedReport: PBIExportableReport | undefined;
  uniqueProfiles: string[];
  filteredReports: PBIExportableReport[];
  selectedProfile: string | undefined;
  setSelectedProfile: (v: string) => void;
  setSelectedReport: (r: PBIExportableReport) => void;
  formData: {
    file_format?: string;
  };
  setFormData: (data: any) => void;
  onProfileChange?: (profile: string) => void;
}

export const ReportScreenshotForm = ({
  selectedReport,
  uniqueProfiles,
  filteredReports,
  selectedProfile,
  setSelectedProfile,
  setSelectedReport,
  formData = {},
  setFormData,
  onProfileChange,
}: Props) => {

  if (formData.file_format === undefined) {
    setFormData({ ...formData, file_format: 'pdf' });
  }

  return (
    <>
      <StyledFieldWrapper>
        <Text>Select a Profile:</Text>
        <Dropdown>
          <Dropdown.Trigger>{selectedProfile || 'Select a profile'}</Dropdown.Trigger>
          <Dropdown.Menu>
            {uniqueProfiles.map(profile => (
            <Dropdown.Item
              key={profile}
              onClick={() => {
                setSelectedProfile(profile);
                onProfileChange?.(profile);
              }}
            >
              {profile}
            </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </StyledFieldWrapper>

      <StyledFieldWrapper>
        <Text>Select a Report:</Text>
        <Dropdown>
          <Dropdown.Trigger>{selectedReport?.reportName || 'Select a report'}</Dropdown.Trigger>
          <Dropdown.Menu>
            {filteredReports.map(report => (
              <Dropdown.Item key={report.reportId} onClick={() => setSelectedReport(report)}>
                {report.reportName}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </StyledFieldWrapper>


      {selectedReport?.pdfDemoFile && (
        <StyledFieldWrapper>
          <Text>
            Sample preview only — final report will be sent to your email. 📩
          </Text>
          <Tooltip
            message={
              selectedReport.pdfDemoFileExpiresAt
                ? `Valid until ${selectedReport.pdfDemoFileExpiresAt.toLocaleString(undefined, {
                  dateStyle: 'medium',
                  timeStyle: 'short',
                })}`
                : 'No expiration info available'
            }
          >
            <a
              href={selectedReport.pdfDemoFile}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#007bff',
                textDecoration: 'none',
                marginTop: '8px',
                display: 'inline-block',
              }}
            >
              View sample report (PDF)
            </a>
          </Tooltip>
        </StyledFieldWrapper>
      )}

    </>
  );
};
